/** Public schedule page (30 min). Override via CRA env: REACT_APP_CALENDLY_SCHEDULE_URL */
const DEFAULT_CALENDLY_SCHEDULE_URL = "https://calendly.com/letsgetvisa/30min";

function resolveCalendlyScheduleUrl(): string {
  const fromEnv = process.env.REACT_APP_CALENDLY_SCHEDULE_URL?.trim();
  if (fromEnv) {
    return fromEnv;
  }
  return DEFAULT_CALENDLY_SCHEDULE_URL;
}

/**
 * Calendly URL for scheduling (AnswerReview, Connect Attorney, etc.).
 */
export const getCalendlyLink = (): string => resolveCalendlyScheduleUrl();

/**
 * Same as {@link getCalendlyLink}; use when merging query params with the URL API.
 */
export function getCalendlyScheduleUrlAsUrl(): URL {
  try {
    return new URL(resolveCalendlyScheduleUrl());
  } catch {
    return new URL(DEFAULT_CALENDLY_SCHEDULE_URL);
  }
}
